import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, DatePicker } from "antd";
import "./Form.css";
import InputForm from "./InputForm";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone"; // VALIDAR DATAS

import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import ProdutoFrame from './ProdutoFrame';
import GrupoProdutoFrame from './GrupoProdutoFrame';
import MarcaFrame from './MarcaFrame';
import ServicoFrame from './ServicoFrame';
import { getUsuario } from "../utils/LoginManager";

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Item: ItemForm } = Form;

export const OPCOES_COMBO_SITUACAO_FIN = [
  {
    key: 'X',
    label: 'Todas as Situações'
  },
  {
    key: 'A',
    label: 'ABERTO'
  },
  {
    key: 'P',
    label: 'PAGO'
  },
]

export const OPCOES_COMBO_SITUACAO_CONTR = [
  {
    key: 'X',
    label: 'Todas as Situações'
  },
  {
    key: '1',
    label: 'VIGENTES'
  },
  {
    key: '0',
    label: 'CANCELADOS'
  },
]

export const OPCOES_COMBO_BLOQUEIO_CONTR = [
  {
    key: 'X',
    label: 'Todas as Situações'
  },
  {
    key: '0',
    label: 'ATIVOS'
  },
  {
    key: '1',
    label: 'BLOQUEADOS'
  },
]

export const OPCOES_COMBO_STATUS_NF = [
  {
    key: 'X',
    label: 'Todos Status'
  },
  {
    key: '0',
    label: 'PENDENTES'
  },
  {
    key: '1',
    label: 'AUTORIZADOS'
  },
  {
    key: '2',
    label: 'ERRO API'
  },
  {
    key: '3',
    label: 'REJEITADAS'
  },
  {
    key: '4',
    label: 'CANCELADAS'
  },
  {
    key: '5',
    label: 'INUTILIZADAS'
  },
]

export const OPCOES_COMBO_TIPO_NF = [
  {
    key: 'X',
    label: 'Todos Tipos'
  },
  {
    key: '55',
    label: 'NFe'
  },
  {
    key: '65',
    label: 'NFCe'
  },
  {
    key: '99',
    label: 'NFSe'
  },
]


export default class PedidoFiltroForm extends Component {
  state = {
    registroFiltros: {
      tipoTela: '',
      buscaDataIni: '',
      buscaDataFim: '',
      buscaControle: '',
      buscaPessoa: { key: '0' },
      buscaProduto: { key: '0' },
      buscaGrupoProduto: { key: '0' },
      buscaMarcaProduto: { key: '0' },
      buscaServico: { key: '0' },
      buscaUsuario: { key: '0' },
      buscaSitFin: { key: 'X' },
      buscaStatusNF: { key: 'X' },
      buscaModeloNF: { key: 'X' },
      buscaSitContr: { key: 'X' },
      buscaVeiculo: '',

      usuario: [],
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.filtros !== propsAnterior.filtros) {
      const usuario = getUsuario();
      this.setState({
        registroFiltros: this.props.filtros,
        usuario
      }, () => {
        // this.refs.ven_pessoa.focus();
      });
    }
  }


  onOK = () => {
    // console.log('onOK: ', this.state.registroFiltros);
    this.props.onFiltrarClick(this.state.registroFiltros);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroFiltros } = this.state;
    registroFiltros[id] = value;
    this.setState({
      [id]: value
    });
  };


  onChangePessoa = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaPessoa'] = event.buscaPessoa;
    this.setState(event);
  }

  onChangeProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaProduto'] = event.buscaProduto;
    this.setState(event);
  }

  onChangeGrupoProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaGrupoProduto'] = event.buscaGrupoProduto;
    this.setState(event);
  }

  onChangeMarcaProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaMarcaProduto'] = event.buscaMarcaProduto;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaUsuario'] = event.buscaUsuario;
    this.setState(event);
  }

  onChangeServico = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaServico'] = event.buscaServico;
    this.setState(event);
  }

  onChangePeriodo = event => {
    const { registroFiltros } = this.state;
    if (event[0]) {
      registroFiltros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      registroFiltros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      registroFiltros
    },
      this.getListaRegistros
    );
  };




  render() {
    const { onCancelarFiltroClick, visivel } = this.props;
    const { usuario } = this.state;
    const { tipoTela, buscaDataIni, buscaDataFim, buscaControle, buscaPessoa,
      buscaProduto, buscaGrupoProduto, buscaMarcaProduto, buscaUsuario, buscaStatusNF, buscaModeloNF, buscaSitContr, buscaBloqueio, buscaSitFin, buscaServico, buscaVeiculo
    } = this.state.registroFiltros;

    // console.log('PedidoFiltroForm.this.state: ', this.state);

    return (
      <Modal
        title={"Filtro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarFiltroClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <Row>

          <Col xs={15} style={{ marginRight: 30 }}>
            <span>Período</span>
            <RangePicker
              style={{ width: "100%" }}
              masker={maskDate}
              value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
              format={dateFormat}
              allowClear={false}
              onChange={this.onChangePeriodo}
            />
          </Col>

          <Col xs={24} sm={8} style={{ marginTop: -3 }}>
            <span>Controle</span>
            <InputForm
              id="buscaControle"
              ref="buscaControle"
              value={buscaControle}
              onChange={this.onChange}
              style={{ width: "100%" }}
            />
          </Col>

          <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <PessoaFrame
              label={(tipoTela === 'VEN' || tipoTela === 'CON' || tipoTela === 'OS' || tipoTela === 'OSSERV' || tipoTela === 'EST') ? "Cliente" : (tipoTela === 'COM' ? "Fornecedor" : 'Cliente/Fornecedor')}
              id="buscaPessoa"
              value={buscaPessoa}
              width={"100%"}
              tipo={(tipoTela === 'VEN' || tipoTela === 'CON') ? "C" : (tipoTela === 'COM' ? "F" : "")}
              onChange={this.onChangePessoa}
              descricaoPrimeiroItem={(tipoTela === 'VEN' || tipoTela === 'OS' || tipoTela === 'CON' || tipoTela === 'EST') ? "Todos os Clientes" : (tipoTela === 'COM' ? "Todos os Fornecedores" : 'Todos os Clientes/Fornecedores')}
            />
          </Col>

          {tipoTela === 'PV' || tipoTela === 'PC' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <ProdutoFrame
                label="Produto"
                id="buscaProduto"
                value={buscaProduto}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Todos os Produtos"
              />
            </Col>
          ) : null}

          {tipoTela === 'PV' || tipoTela === 'PC' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <GrupoProdutoFrame
                label="Grupo Produto"
                id="buscaGrupoProduto"
                value={buscaGrupoProduto}
                width={"100%"}
                onChange={this.onChangeGrupoProduto}
                descricaoPrimeiroItem="Todos os Grupos de Produto"
              />
            </Col>
          ) : null}

          {tipoTela === 'PV' || tipoTela === 'PC' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <MarcaFrame
                label="Marca Produto"
                id="buscaMarcaProduto"
                value={buscaMarcaProduto}
                width={"100%"}
                onChange={this.onChangeMarcaProduto}
                descricaoPrimeiroItem="Todos os Grupos de Produto"
              />
            </Col>
          ) : null}

          {tipoTela === 'VEN' || tipoTela === 'OS' || tipoTela === 'ORC' || tipoTela === 'CON' || tipoTela === 'EMINF' || tipoTela === 'CONTR' || tipoTela === 'CTRPGTO' || tipoTela === 'PV' || tipoTela === 'OSSERV' || tipoTela === 'OSAVULSOS' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <UsuarioFrame
                label="Vendedor"
                id="buscaUsuario"
                value={buscaUsuario}
                width={"100%"}
                vendedor={1}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Todos os Vendedores"
              />
            </Col>
          ) : null}

          {tipoTela === 'CONTR' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Situação Contrato</span>
              <InputForm
                type="select"
                id="buscaSitContr"
                ref="buscaSitContr"
                value={buscaSitContr}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_SITUACAO_CONTR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'CONTR' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Bloqueio</span>
              <InputForm
                type="select"
                id="buscaBloqueio"
                ref="buscaBloqueio"
                value={buscaBloqueio}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_BLOQUEIO_CONTR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'EMINF' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Modelo NF</span>
              <InputForm
                type="select"
                id="buscaModeloNF"
                ref="buscaModeloNF"
                value={buscaModeloNF}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_NF}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'EMINF' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Status NF</span>
              <InputForm
                type="select"
                id="buscaStatusNF"
                ref="buscaStatusNF"
                value={buscaStatusNF}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_STATUS_NF}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'VEN' || tipoTela === 'OS' || tipoTela === 'EMINF' || tipoTela === 'TIT' || tipoTela === 'CTRPGTO' || tipoTela === 'FFI' || tipoTela === 'CPR' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Situação Financeira</span>
              <InputForm
                type="select"
                id="buscaSitFin"
                ref="buscaSitFin"
                value={buscaSitFin}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_SITUACAO_FIN}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'OSSERV' ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <ServicoFrame
                label="Serviço"
                id="buscaServico"
                value={buscaServico}
                width={"100%"}
                onChange={this.onChangeServico}
                descricaoPrimeiroItem="Todos os Serviços"
              />
            </Col>
          ) : null}

          {(tipoTela === 'OS' || tipoTela === 'ORC') && usuario && usuario.par_veiculos_clientes ? (
            <Col xs={24} sm={8} style={{ marginTop: -20 }}>
              <span>Veículo do Cliente</span>
              <InputForm
                id="buscaVeiculo"
                ref="buscaVeiculo"
                value={buscaVeiculo}
                onChange={this.onChange}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

        </Row>

        <div>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                >
                  Filtrar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarFiltroClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PedidoFiltroForm.js